import { DataGrid, type DataGridProps } from '@shared/components';

import QuestionListNoRowOverlay from '../no-rows-overlay';

export type QuestionListDataGridProps = Pick<DataGridProps, 'rows' | 'columns'>;

export default function UpdateQuestionStatusListDataGrid(
  props: Readonly<QuestionListDataGridProps>,
) {
  const { rows, columns } = props;

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      columnHeaderHeight={48}
      rowHeight={56}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        boxShadow: 'none',
        '& .MuiDataGrid-row:hover': {
          backgroundColor: 'transparent',
          cursor: 'default',
        },
        '& .MuiDataGrid-row.MuiDataGrid-row': {
          backgroundColor: 'transparent',
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderColor: theme.palette.divider,
        },
        '.MuiDataGrid-cell': {
          padding: theme.spacing(3),
        },
      })}
      disableColumnMenu
      hideFooter
      slots={{
        noRowsOverlay: QuestionListNoRowOverlay,
      }}
    />
  );
}
